<!-- 召回通知单列表 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 日期 -->
                                    <df-date v-if="formOneValue.fieldType == 'date'"
                                       v-model="sendDataInfo[formOneValue.entityField]"
                                       @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                       :isShowLong="false" :isdisabled="formOneValue.isChange == 0">
                                    </df-date>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                       :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                             slot="append" icon="el-icon-search">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <!-- 检索方案 -->
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                          :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                             slot="append" icon="el-icon-search"
                                             :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'"
                                       :disabled="formOneValue.isChange == 0" @visible-change="selectChange"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                          :key="matItem.key"
                                          :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                          :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                    </el-select>
                                    <el-select clearable size="mini"
                                       v-else-if="formOneValue.entityField == 'surgeryType'"
                                       @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                       @change="$forceUpdate()" v-model="sendDataInfo.surgeryType" placeholder="请选择">
                                       <el-option v-for="item in surgeryTypeList" :key="item.id"
                                          :label="item.surgeryName" :value="item.id">
                                       </el-option>
                                    </el-select>
                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                    <el-select clearable size="mini"
                                       v-else-if="formOneValue.entityField == 'saleOrgName'"
                                       :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.XSZZ"
                                          :key="dictionariesKey" :label="dictionariesValue.diName"
                                          :value="dictionariesValue.diValue"></el-option>
                                    </el-select>
                                    <!-- 账期 -->
                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" type="number"
                                       v-else-if="formOneValue.entityField == 'credit'"
                                       :disabled="formOneValue.isChange == 0"
                                       v-model="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength"></el-input>
                                    <el-input class="form_codition" v-else type="text"
                                       @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                       v-model.trim="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength"
                                       :disabled="formOneValue.isChange == 0"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                          formOneValue.fieldType, formOneValue.formatterContent) }}
                                    </span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细操作 -->
                           <el-form :inline="true" size="mini">
                              <!-- 明细信息 -->
                              <el-table class="baseTable" v-if="mxForm" ref="mxTableRef"
                                 :data="sendDataInfo.woApplyDetails" border size="mini" :height="mxHeight">
                                 <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                 <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField"
                                    v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                    v-if="formOneValue.isShow == 1" :min-width="formOneValue.fieldWeight"
                                    show-overflow-tooltip>
                                    <template slot-scope="scope">
                                       <span v-if="formOneValue.isRift == 1">
                                          <a
                                             @click="toDetail(sendDataInfo.woApplyDetails[scope.$index][formOneValue.riftField])">
                                             {{
                                                sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                             }}</a>
                                       </span>
                                       <!-- 生产日期 -->
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span
                                             v-if="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                             {{
                                                $common.getLocalTime(sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField])
                                             }}
                                          </span>
                                       </span>
                                       <span v-else>
                                          {{
                                             sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                          }}
                                       </span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
               @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchSchemeOther :oneFlag="oneFlag" ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true"
         :append-to-body="true">
         <el-table :data="dialogList" border style="width: 100%">
            <el-table-column prop="level" label="类型" width="50">
               <template slot-scope="{row}">
                  <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                     {{ row.level == 0 ? "拦截" : '预警' }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column prop="data" label="内容" min-width="180">
            </el-table-column>
            <el-table-column prop="validity" label="有效期" min-width="100">
               <template slot-scope="{row}">
                  {{ $common.getLocalTime(row.validity) }}
               </template>
            </el-table-column>
         </el-table>
         <span slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
         </span>
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <div v-show="false">{{ some }}</div>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
   name: "wdtOrdeAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         detaislDataInfo: {},
         showTabs: "",
         formDataList: [],
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         seId: "",
         seType: "",
         seIndex: "",
         sField: "", // 赋值字段
         fField: "", //焦点字段
         parentSearchData: {},
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         requesUrl: "",
         token: {
            token: sessionStorage.getItem("token"),
         },
         inputel: [],
         dictionariesData: {},
         surgeryTypeList: [],
         some: 0,
         oneFlag: false,
         //---------------
         showDialog: false,
         dialogList: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.woApplyDetails": {
			handler: function (newValue, oldValue) {
				this.sendDataInfo.totalCount = 0; //总条目数
				let totalMoney = 0;
				let totalGprofit = 0;
				let totalNumber = 0;
				let totalCostMoney = 0;
				for (let i = 0; i < newValue.length; i++) {
					const item = newValue[i];
					// 累加总金额（暂存）
					totalMoney = NP.plus(totalMoney, (item.psmoney || 0));
					totalGprofit = NP.plus(totalGprofit, (item.gross || 0));
					totalNumber = NP.plus(totalNumber, (item.woadPnumber || 0));
					totalCostMoney = NP.plus(totalCostMoney, (item.costMoney || 0));
				}
				// 一次性更新总计数据
				this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
				this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, totalGprofit);
				this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, totalNumber);
				this.sendDataInfo.totalCostMoney = this.$common.getDecimalInfo(3, totalCostMoney);
				this.sendDataInfo.totalCount = newValue.length;
			},
			deep: true,
		},
      "sendDataInfo.stName": {
         handler: function (newstr, oldValue) {
            if (!newstr) {
               this.sendDataInfo.stId = "";
            }
         },
         deep: true,
      },
      "sendDataInfo.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               if (
                  this.dataActionBox.actionType == 0
               ) {
                  this.sendDataInfo.cmId = "";
                  this.sendDataInfo.salesId = "";
                  this.sendDataInfo.salesName = "";
                  this.sendDataInfo.secondcmName = "";
                  this.sendDataInfo.secondcmId = "";
                  this.sendDataInfo.caiId = "";
                  this.sendDataInfo.caiAddress = "";
                  this.sendDataInfo.recId = "";
                  this.sendDataInfo.recName = "";
               }
            } else if (newValue != oldValue && oldValue != "") {
               if (
                  this.dataActionBox.actionType == 0
               ) {
                  // this.sendDataInfo.salesId = "";
                  // this.sendDataInfo.salesName = "";
                  // this.sendDataInfo.caiId = "";
                  // this.sendDataInfo.caiAddress = "";
                  // this.sendDataInfo.recId = "";
                  // this.sendDataInfo.recName = "";
               }
            }
         },
         deep: true,
      },
      "sendDataInfo.dismode": {
         handler: function (newstr, oldValue) {
            console.log(newstr, "dismodedismode")
            this.$nextTick(() => {
               let newValue = newstr.replace(/\s*/g, "");
               this.sendDataInfo.dismode = newValue;
               if (newValue == "物流") {
                  // this.sendDataInfo.companyName = "";
                  // this.sendDataInfo.loId = "";
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        item.isShow = 1;
                     }
                     if (item.entityField == "pickupName") {
                        item.isShow = 0;
                     }
                  });
               } else if (newValue == "自提") {
                  // this.sendDataInfo.pickupName = "";
                  // this.sendDataInfo.pickupId = "";
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "pickupName") {
                        item.isShow = 1;
                     }
                     if (item.entityField == "companyName") {
                        item.isShow = 0;
                     }
                  });
               } else {

                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        this.sendDataInfo.companyName = "";
                        this.sendDataInfo.loId = "";
                        item.isShow = 0;
                     }
                     if (item.entityField == "pickupName") {
                        this.sendDataInfo.pickupName = "";
                        this.sendDataInfo.pickupId = "";
                        item.isShow = 0;
                     }
                  });
               }
               var index = 0
               this.tabForm[0].jurconfigform.forEach(item => {
                  if (item.isShow == 1) {
                     item.isIndex = index
                     index++
                  }
               })
            });
            this.some++;
            this.$forceUpdate();
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      imgur() {
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val && (val != "" || val != undefined)) {
            if (this.seType == "cmName") {
               this.showDialog = false;
               let cmNameFlag = -1;
               //销售单位
               this.$http.checkCustomerSale({
                  //校验单位
                  formId: this.formDataList[0].jciId, //表单ID
                  unitId: val.cmId, //单位ID
               }).then((res) => {
                  this.dialogList = []
                  if (res && res.status == 200) {
                     if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                           this.dialogList.push(item)
                        })
                        cmNameFlag = this.dialogList.findIndex(
                           (item) => item.level == 0
                        );
                        this.showDialog = true;
                     }
                     if (cmNameFlag == -1) {
                        this.parentSearchData.cmId = val.cmId;
                        this.sendDataInfo.cmId = val.cmId;
                        this.sendDataInfo.cmName = val.cmName;
                        if (val.salesName && val.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                           //对方业务员
                           this.$http.checkSalesSale({
                              //校验对方业务员
                              formId: this.formDataList[0].jciId, //表单ID
                              salesId: val.salesId, //业务员ID
                           }).then((res) => {
                              if (res && res.status == 200) {
                                 let flag = -1;
                                 if (res.result != null && res.result.length > 0) {
                                    res.result.forEach(item => {
                                       this.dialogList.push(item)
                                    })
                                    flag = this.dialogList.findIndex((item) => item.level == 0);
                                    this.showDialog = true;
                                 }
                                 if (flag == -1) {
                                    this.sendDataInfo.salesName = val.salesName;
                                    this.sendDataInfo.salesId = val.salesId;
                                    if (val.recName && val.recId && this.sField.indexOf('recName') != -1 && this.sField.indexOf('recId') != -1) {
                                       //收货员
                                       this.$http.checkRecSalesSale({
                                          //校验收货员
                                          formId: this.formDataList[0].jciId, //表单ID
                                          salesId: val.recId, //业务员ID
                                       }).then((res) => {
                                          if (res && res.status == 200) {
                                             let salesFlag = -1;
                                             if (res.result != null && res.result.length > 0) {
                                                res.result.forEach(item => {
                                                   this.dialogList.push(item)
                                                })
                                                salesFlag = this.dialogList.findIndex((item) => item.level == 0);
                                                this.showDialog = true;
                                             }
                                             if (salesFlag == -1) {
                                                this.paramValue(val);
                                             }
                                          } else {
                                             this.lineMessageBox(res);
                                             return false;
                                          }
                                       }).catch((rej) => {
                                          this.lineMessageBox(rej);
                                       });
                                    } else {
                                       this.paramValue(val);
                                    }
                                 } else {
                                    this.showDialog = true;
                                 }
                              } else {
                                 this.lineMessageBox(res);
                                 return false;
                              }
                           }).catch((rej) => {
                              this.lineMessageBox(rej);
                           });
                        } else {
                           this.paramValue(val)
                        }
                     } else {
                        this.showDialog = true;
                     }
                  } else {
                     this.lineMessageBox(res);
                     this.parentSearchData.cmId = "";
                     this.clearValue();
                  }
               }).catch((rej) => {
                  this.lineMessageBox(rej);
                  this.parentSearchData.cmId = "";
                  this.clearValue();
               });
            } else if (this.seType == "salesName") {
               this.showDialog = false;
               //对方业务员
               this.$http.checkSalesSale({
                  //校验对方业务员
                  formId: this.formDataList[0].jciId, //表单ID
                  salesId: val.salesId, //业务员ID
               }).then((res) => {
                  this.dialogList = []
                  if (res && res.status == 200) {
                     let flag = -1;
                     if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                           this.dialogList.push(item)
                        })
                        flag = this.dialogList.findIndex(
                           (item) => item.level == 0
                        );
                        this.showDialog = true;
                     }
                     if (flag == -1) {
                        this.paramValue(val);
                     }
                  } else {
                     this.lineMessageBox(res);
                     this.clearValue();
                     return false;
                  }
               }).catch((rej) => {
                  this.lineMessageBox(rej);
                  this.clearValue();
               });
            } else if (this.seType == "coName") {
               //货主
               this.$http.checkSuComey({
                  //校验对方业务员
                  formId: this.formDataList[0].jciId, //表单ID
                  coId: val.coId, //货主ID
               }).then((res) => {
                  this.dialogList = []
                  if (res && res.status == 200) {
                     let flag = -1;
                     if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                           this.dialogList.push(item)
                        })
                        flag = this.dialogList.findIndex(item => item.level == 0);
                        this.showDialog = true;
                     }
                     if (flag == -1) {
                        this.coId = val.coId;
                        this.sendDataInfo.ormId = this.ormId;
                        this.paramValue(val);
                     } else {
                        this.showDialog = true;
                     }
                  } else {
                     this.lineMessageBox(res);
                     this.clearValue();
                     return false;
                  }
               }).catch((rej) => {
                  this.lineMessageBox(rej);
                  this.clearValue();
               });
            } else if (this.seType == "pickupName") {
               //自提人
               this.$http.fromruleCheckSuDismode({
                  //校验自提人
                  formId: this.formDataList[0].jciId, //表单ID
                  pickupId: val.pickupId, //自提人ID
                  dismode: this.sendDataInfo.dismode

               }).then((res) => {
                  this.dialogList = []
                  if (res && res.status == 200) {
                     let flag = -1;
                     if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                           this.dialogList.push(item)
                        })
                        flag = this.dialogList.findIndex(item => item.level == 0);
                        this.showDialog = true;
                     }
                     if (flag == -1) {
                        this.paramValue(val);
                     } else {
                        this.showDialog = true;
                     }
                  } else {
                     this.lineMessageBox(res);
                     this.clearValue();
                     return false;
                  }
               }).catch((rej) => {
                  this.lineMessageBox(rej);
                  this.clearValue();
               });
            } else if (this.seType == "recName") {
               //收货员
               this.$http.checkRecSalesSale({
                  //校验收货员
                  formId: this.formDataList[0].jciId, //表单ID
                  salesId: val.salesId, //业务员ID
               }).then((res) => {
                  this.dialogList = []
                  if (res && res.status == 200) {
                     let flag = -1;
                     if (res.result != null && res.result.length > 0) {
                        res.result.forEach(item => {
                           this.dialogList.push(item)
                        })
                        flag = this.dialogList.findIndex(item => item.level == 0);
                        this.showDialog = true;
                     }
                     if (flag == -1) {
                        this.paramValue(val);
                     }
                  } else {
                     this.lineMessageBox(res);
                     this.clearValue();
                     return false;
                  }
               }).catch((rej) => {
                  this.lineMessageBox(rej);
                  this.clearValue();
               });
            } else if (this.seType == "ht") {
               for (let key in val) {
                  this.sendDataInfo[key] = val[key];
               }
               this.parentSearchData.cmId = val.cmId;
            } else {
               this.paramValue(val);
            }
         }
      },
      // 清除赋值字段数据
      clearValue() {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = "";
         });
      },
      lineMessageBox(data) {
         console.log(data);

         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },
      // 赋值字段
      paramValue(val, flag) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.$set(this.sendDataInfo, item, val[item])
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex, this.fField);
         });
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField, fField) {
         this.parentSearchData = {}
         if (type == "salesName" || type == "caiAddress" || type == "recName" || type == 'secondcmName') {
            if (this.sendDataInfo.cmId == "") {
               return this.$message({
                  message: "请先选择销售单位",
                  type: "warning",
               });
            }
         }
         this.oneFlag = false
         if (type == 'caiAddress') {
            this.oneFlag = true
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         for (const key in this.sendDataInfo) {
            if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
               this.parentSearchData[key] = this.sendDataInfo[key];
            } else {
               this.parentSearchData[key] = ""
            }
         }
         if (type == 'secondcmName') {
            delete this.parentSearchData.stId
         }
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },


      initActionBox(sendDataInfo) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
      },

      openBox() {
         this.pageType = this.actionData.type;
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            if (oldData.length > 0) {
               this.sendDataInfo.cmName = oldData[0].cmName
               this.sendDataInfo.cmId = oldData[0].cmId
               this.sendDataInfo.coId = oldData[0].coId
               this.sendDataInfo.coName = oldData[0].coName
            }
            this.sendDataInfo.woApplyDetails = oldData
            this.sendDataInfo.woApplyDetails.forEach(item => {
               item.woadPnumber = item.orderNum
            })
            this.checkIsBuyer();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";

            var dataInfo = JSON.parse(JSON.stringify(oldData));

            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
            this.sendDataInfo.rcnId = dataInfo.rcnId
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
               this.initFocus();
            }, 16.7);
         });
      },
      // 判断是不是采购员
      checkIsBuyer() {
         if (this.dataActionBox.actionType != 0) return;
         let info = JSON.parse(sessionStorage.getItem("userInfo"));
         let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
         if (ormInfo.isDefaultopm == 1) {
            if (info.opmSalesperson == 1) {
               this.sendDataInfo.depName = info.depName;
               this.sendDataInfo.depId = info.depId;
               this.sendDataInfo.opmName = info.opmName;
               this.sendDataInfo.opmId = info.opmId;
               this.tabForm[0].jurconfigform.forEach((item) => {
                  if (
                     item.entityField == "opmName" ||
                     item.entityField == "depName"
                  )
                     item.isChange = 0;
               });
            }
         }
      },
      sendDataAction(sendDataInfo) {
         console.log(sendDataInfo);
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               this.$message({
                  message: "请完善主表单必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.orderSource="旺店通"
         var responseData = await this.$http.addSalesOrder(sendData);
         if (responseData.status == 200) {
            this.init();
            this.$message.success("操作成功");
            this.$emit("drawerCancel", true);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value === val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key === val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });

            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               // if (key.jurconfigform[index].isShow == 1)
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

            }
         });
         var arr = [];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
         this.sendDataInfo.woamSaledate = this.$moment().valueOf();
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 输入框切换焦点
      nextFocus(index, fField) {
         if (fField == "keydown") {
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },
      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [63],
         });
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取字典数据
      async dictSurgeryqueryList() {
         let responseData = await this.$http.dictSurgeryqueryList({ surgeryName: "" });
         if (responseData.status == 200) {
            this.surgeryTypeList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgur();
      this.dictSurgeryqueryList()
      this.getPartDictionariesData()
      this.$nextTick(() => {
         this.openBox();

      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>